export interface IWorkflowService {
  completeInput(correlationId: string, data: any, productCode?: any, metadata?: any);
  updateData(correlationId: string, partyId: string, data: any, stopPropogation: boolean);

}

export enum WorkflowKind {
    ProductFlow,
    Referral
}